'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = possibleConstructorReturn;
function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/emoji-mart/dist/polyfills/possibleConstructorReturn.js
 ** module id = 1607
 ** module chunks = 3
 **/